import CompanyTooltip from "./CompanyTooltip";

export default CompanyTooltip;
